import * as React from "react";

import "./ExplanationText.scss";

interface Props {
    children: React.ReactNode;
}

export class ExplanationText extends React.Component<Props> {
    public render() {
        return <div className="explanation-text">
            {this.props.children}
        </div>
    }
}